<template>
  <div>
    <app-cells>
      <app-form-group label="Date of requests" class="form-group--no-indent">
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_balance"
            class="custom-date-time-picker custom-date-time-picker--range"
            v-model="filter_dates"
            :custom-shortcuts="custom_shortcuts"
            shortcut="last60Days"
            @is-hidden="onIsHiddenPicker"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            color="#77b017"
            button-color="#77b017"
            overlay
            no-header
            no-label
            locale="en"
            range
            noClearButton
          />
          <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
        </div>
      </app-form-group>
      <app-form-group label="Country group" class="form-group--no-indent">
        <app-select
          @input="onInputCountryGroup"
          v-model="country_group"
          :options="country_groups_options"
          :reduce="item => item.code"
          placeholder="Country group"
          class="select--200"
        />
      </app-form-group>
      <app-form-group label="Country" class="form-group--no-indent">
        <app-select
          @input="onInputCountryGroup"
          v-model="country"
          :options="country_options"
          :reduce="item => item.code"
          placeholder="Country"
          class="select--200"
        />
      </app-form-group>
      <app-form-group label="Language" class="form-group--no-indent">
        <app-select
          @input="onInputCountryGroup"
          v-model="language"
          :options="language_options"
          :reduce="item => item.code"
          placeholder="Language"
          class="select--200"
        />
      </app-form-group>
      <app-form-group label="Device" class="form-group--no-indent">
        <app-select
          @input="onInputCountryGroup"
          v-model="device"
          :options="device_options"
          :reduce="item => item.code"
          placeholder="Device"
          class="select--200"
        />
      </app-form-group>
    </app-cells>
    <app-cells>
      <app-form-group label="Climbing" class="form-group--no-indent">
        <app-cells :indent="false">
          <app-radio
            v-for="radio of climbing_radio_options"
            :key="radio.label"
            v-model="climbing_radio"
            :value="radio.value"
            name="climbing"
            :checked="climbing_radio === radio.value"
            @change="onInputCountryGroup"
          >
            <template #label>{{ radio.label }}</template>
          </app-radio>
        </app-cells>
      </app-form-group>
      <app-form-group label="Safari" class="form-group--no-indent">
        <app-cells :indent="false">
          <app-radio
            v-for="radio of safari_radio_options"
            :key="radio.label"
            v-model="safari_radio"
            :value="radio.value"
            name="safari"
            :checked="safari_radio === radio.value"
            @change="onInputCountryGroup"
          >
            <template #label>{{ radio.label }}</template>
          </app-radio>
        </app-cells>
      </app-form-group>
      <app-form-group label="Day trips" class="form-group--no-indent">
        <app-cells :indent="false">
          <app-radio
            v-for="radio of trips_radio_options"
            :key="radio.label"
            v-model="trips_radio"
            :value="radio.value"
            name="trips"
            :checked="trips_radio === radio.value"
            @change="onInputCountryGroup"
          >
            <template #label>{{ radio.label }}</template>
          </app-radio>
        </app-cells>
      </app-form-group>
      <app-form-group label="Islands" class="form-group--no-indent">
        <app-cells :indent="false">
          <app-radio
            v-for="radio of islands_radio_options"
            :key="radio.label"
            v-model="islands_radio"
            :value="radio.value"
            name="islands"
            :checked="islands_radio === radio.value"
            @change="onInputCountryGroup"
          >
            <template #label>{{ radio.label }}</template>
          </app-radio>
        </app-cells>
      </app-form-group>
    </app-cells>
    <app-cells class="cells--start-vertical">
      <app-form-group label="Status" class="form-group--no-indent">
        <app-select
          @input="onInputCountryGroup"
          v-model="status"
          :options="status_options"
          :reduce="item => item.code"
          multiple
          placeholder="Status"
          class="select--300"
        />
      </app-form-group>
      <app-form-group label="Source" class="form-group--no-indent">
        <app-select
          @input="onInputCountryGroup"
          v-model="source"
          :options="source_options"
          :reduce="item => item.code"
          multiple
          placeholder="Source"
          class="select--300"
        />
      </app-form-group>
      <app-form-group label="Manager" class="form-group--no-indent">
        <app-select
          @input="onInputCountryGroup"
          v-model="manager"
          :options="managers_options"
          :reduce="item => item.id"
          :display-field="option => `${option.first_name} ${option.last_name}`"
          label="first_name"
          placeholder="Sales manager"
          class="select--300"
        />
      </app-form-group>
    </app-cells>
    <div class="lead-holder">
      <app-spinner v-if="!is_loaded" />
      <template v-else>
        <div class="info-row">
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.count }}</span>
              <span class="info-row__text">Total count</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.lead }}</span>
              <span class="info-row__text">Lead</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.negotiation }}</span>
              <span class="info-row__text">Negotiation</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.pre_confirmed }}</span>
              <span class="info-row__text">Pre confirmed</span>
            </div>
          </div>
        </div>
        <div class="info-row">
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.nurture }}</span>
              <span class="info-row__text">Nurture</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.no_response }}</span>
              <span class="info-row__text">No response</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.lost }}</span>
              <span class="info-row__text">Lost</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.refused }}</span>
              <span class="info-row__text">Refused</span>
            </div>
          </div>
        </div>
        <div class="info-row">
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.postponed }}</span>
              <span class="info-row__text">Postponed</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.deposit_paid }}</span>
              <span class="info-row__text">Deposit paid</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.full_paid }}</span>
              <span class="info-row__text">Full paid</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.completed  }}</span>
              <span class="info-row__text">Completed</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.confirmed }}</span>
              <span class="info-row__text">Confirmed total</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ request_data.conversion }}%</span>
              <span class="info-row__text">Conversion</span>
            </div>
          </div>
        </div>
        <div class="charts-grid"><highcharts :options="graph_request_options" /></div>
        <app-cells><h2 class="title">Languages</h2></app-cells>
        <div class="info-row">
          <div v-for="(value, key) in languages_data" :key="key" class="info-row__item" v-show="value">
            <div class="info-row__content">
              <span class="info-row__value">{{ value }}</span>
              <span class="info-row__text">{{ key }}</span>
            </div>
          </div>
        </div>
        <div class="charts-grid"><highcharts :options="graph_request_languages_options" /></div>
        <app-cells><h2 class="title">Activities</h2></app-cells>
        <div class="info-row">
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ activities_data.climbing }}</span>
              <span class="info-row__text">Climbing</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ activities_data.safari }}</span>
              <span class="info-row__text">Safari</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ activities_data.day_trip }}</span>
              <span class="info-row__text">Day trips</span>
            </div>
          </div>
          <div class="info-row__item">
            <div class="info-row__content">
              <span class="info-row__value">{{ activities_data.island }}</span>
              <span class="info-row__text">Islands</span>
            </div>
          </div>
        </div>
        <div class="charts-grid"><highcharts :options="graph_request_activities_options" /></div>
        <app-cells>
          <h2 class="title">Tour dates</h2>
          <div class="date-picker-wrapper">
            <VueCtkDateTimePicker
              id="date_picker_balance"
              class="custom-date-time-picker custom-date-time-picker--range"
              v-model="filter_dates_dates"
              :custom-shortcuts="custom_shortcuts_dates"
              shortcut="thisYear"
              @is-hidden="onIsHiddenPickerDates"
              format="YYYY-MM-DD"
              formatted="ll"
              label="Select dates"
              color="#77b017"
              button-color="#77b017"
              overlay
              no-header
              no-label
              locale="en"
              range
              noClearButton
            />
            <div v-if="date_picker_dates_error" class="date-picker-wrapper__error">Choose an end date</div>
          </div>
        </app-cells>
        <app-grid :indent="true">
          <template #item-1>
            <div class="info-row">
              <div class="info-row__item">
                <div class="info-row__content">
                  <span class="info-row__value">{{ pax_data.climbing }}</span>
                  <span class="info-row__text">Climbing</span>
                </div>
              </div>
            </div>
            <highcharts :options="graph_climbing_options" />
          </template>
          <template #item-2>
            <div class="info-row">
              <div class="info-row__item">
                <div class="info-row__content">
                  <span class="info-row__value">{{ pax_data.safari }}</span>
                  <span class="info-row__text">Safari</span>
                </div>
              </div>
            </div>
            <highcharts :options="graph_safari_options" />
          </template>
        </app-grid>
        <app-grid :indent="true">
          <template #item-1>
            <app-cells><h2 class="title">Weekdays</h2></app-cells>
            <highcharts :options="graph_request_weekdays_options" />
          </template>
          <template #item-2>
            <app-cells>
              <h2 class="title">Hours</h2>
              <app-form-group class="form-group--no-indent" label_left label="Group by (hours)" label-for="hours-filter">
                <app-input
                  v-model.number="hours_filter"
                  @change.native="fetchRequestHours"
                  type="number"
                  min="1"
                  id="hours-filter"
                />
              </app-form-group>
            </app-cells>
            <highcharts :options="graph_request_hours_options" />
          </template>
        </app-grid>
        <app-grid>
          <template #item-1>
            <app-cells><h2 class="title">Assignment time (Minutes)</h2></app-cells>
            <highcharts :options="graph_assignment_options" />
          </template>
          <template #item-2>
            <app-cells><h2 class="title">Confirmation days</h2></app-cells>
            <highcharts :options="graph_confirmation_options" />
          </template>
        </app-grid>
        <app-cells>
          <h2 class="title">Countries</h2>
          <span class="status-tag" :style="{ 'backgroundColor': '#77b017' }">{{ countries_data.exist }}</span>
          <span class="status-tag" :style="{ 'backgroundColor': '#e85c20' }">{{ countries_data.missing }}</span>
        </app-cells>
        <v-client-table
          :data="table_countries.items"
          :columns="table_countries.columns"
          :options="table_countries.options"
          class="table-default"
        >
          <template #h__country><div class="table-default__left">Country</div></template>
          <template #h__pre_confirmed>Pre<br>confirmed</template>
          <template #h__deposit_paid>Deposit<br>paid</template>
          <template #h__full_paid>Full<br>paid</template>
          <template #index="{ row, index }">{{ index }}</template>
          <template #country="{ row }">
            <div class="table-default__left table-default__controls">
              <span :class="`fflag ff-md fflag-${row[1].country_code || 'empty'}`"></span>
              {{ row[0] }}
            </div>
          </template>
          <template #count="{ row }">{{ row[1].count }}</template>
          <template #lead="{ row }">{{ row[1].lead }}</template>
          <template #negotiation="{ row }">{{ row[1].negotiation }}</template>
          <template #nurture="{ row }">{{ row[1].nurture }}</template>
          <template #postponed="{ row }">{{ row[1].postponed }}</template>
          <template #no_response="{ row }">{{ row[1].no_response }}</template>
          <template #lost="{ row }">{{ row[1].lost }}</template>
          <template #refused="{ row }">{{ row[1].refused }}</template>
          <template #pre_confirmed="{ row }">{{ row[1].pre_confirmed }}</template>
          <template #deposit_paid="{ row }">{{ row[1].deposit_paid }}</template>
          <template #full_paid="{ row }">{{ row[1].full_paid }}</template>
          <template #completed="{ row }">{{ row[1].completed }}</template>
          <template #conversion="{ row }">{{ row[1].conversion }}%</template>
          <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
          <template #amount="{ row }">{{ row[1].amount.toLocaleString() }}$</template>
          <template #commission="{ row }">{{ row[1].commission.toLocaleString() }}$</template>
        </v-client-table>
        <app-cells><h2 class="title">Currency</h2></app-cells>
        <v-client-table
          :data="table_currency.items"
          :columns="table_currency.columns"
          :options="table_currency.options"
          class="table-default"
        >
          <template #h__country><div class="table-default__left">Currency</div></template>
          <template #h__pre_confirmed>Pre<br>confirmed</template>
          <template #h__deposit_paid>Deposit<br>paid</template>
          <template #h__full_paid>Full<br>paid</template>
          <template #index="{ row, index }">{{ index }}</template>
          <template #country="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
          <template #count="{ row }">{{ row[1].count }}</template>
          <template #lead="{ row }">{{ row[1].lead }}</template>
          <template #negotiation="{ row }">{{ row[1].negotiation }}</template>
          <template #nurture="{ row }">{{ row[1].nurture }}</template>
          <template #postponed="{ row }">{{ row[1].postponed }}</template>
          <template #no_response="{ row }">{{ row[1].no_response }}</template>
          <template #lost="{ row }">{{ row[1].lost }}</template>
          <template #refused="{ row }">{{ row[1].refused }}</template>
          <template #pre_confirmed="{ row }">{{ row[1].pre_confirmed }}</template>
          <template #deposit_paid="{ row }">{{ row[1].deposit_paid }}</template>
          <template #full_paid="{ row }">{{ row[1].full_paid }}</template>
          <template #completed="{ row }">{{ row[1].completed }}</template>
          <template #conversion="{ row }">{{ row[1].conversion }}%</template>
          <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
          <template #amount="{ row }">{{ row[1].amount.toLocaleString() }}$</template>
          <template #commission="{ row }">{{ row[1].commission.toLocaleString() }}$</template>
        </v-client-table>
        <app-cells><h2 class="title">Tour operators</h2></app-cells>
        <v-client-table
          :data="table_operators.items"
          :columns="table_operators.columns"
          :options="table_operators.options"
          class="table-default table-default--indent"
        >
          <template #h__country><div class="table-default__left">Tour operator</div></template>
          <template #h__pre_confirmed>Pre<br>confirmed</template>
          <template #h__deposit_paid>Deposit<br>paid</template>
          <template #h__full_paid>Full<br>paid</template>
          <template #index="{ row, index }">{{ index }}</template>
          <template #country="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
          <template #count="{ row }">{{ row[1].count }}</template>
          <template #lead="{ row }">{{ row[1].lead }}</template>
          <template #negotiation="{ row }">{{ row[1].negotiation }}</template>
          <template #nurture="{ row }">{{ row[1].nurture }}</template>
          <template #postponed="{ row }">{{ row[1].postponed }}</template>
          <template #no_response="{ row }">{{ row[1].no_response }}</template>
          <template #lost="{ row }">{{ row[1].lost }}</template>
          <template #refused="{ row }">{{ row[1].refused }}</template>
          <template #pre_confirmed="{ row }">{{ row[1].pre_confirmed }}</template>
          <template #deposit_paid="{ row }">{{ row[1].deposit_paid }}</template>
          <template #full_paid="{ row }">{{ row[1].full_paid }}</template>
          <template #completed="{ row }">{{ row[1].completed }}</template>
          <template #conversion="{ row }">{{ row[1].conversion }}%</template>
          <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
          <template #amount="{ row }">{{ row[1].amount.toLocaleString() }}$</template>
          <template #commission="{ row }">{{ row[1].commission.toLocaleString() }}$</template>
        </v-client-table>
        <div class="charts-grid"><highcharts :options="graph_request_source_options" /></div>
        <app-cells><h2 class="title">Source</h2></app-cells>
        <v-client-table
          :data="table_source.items"
          :columns="table_source.columns"
          :options="table_source.options"
          class="table-default"
        >
          <template #h__country><div class="table-default__left">Source</div></template>
          <template #h__pre_confirmed>Pre<br>confirmed</template>
          <template #h__deposit_paid>Deposit<br>paid</template>
          <template #h__full_paid>Full<br>paid</template>
          <template #index="{ row, index }">{{ index }}</template>
          <template #country="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
          <template #count="{ row }">{{ row[1].count }}</template>
          <template #lead="{ row }">{{ row[1].lead }}</template>
          <template #negotiation="{ row }">{{ row[1].negotiation }}</template>
          <template #nurture="{ row }">{{ row[1].nurture }}</template>
          <template #postponed="{ row }">{{ row[1].postponed }}</template>
          <template #no_response="{ row }">{{ row[1].no_response }}</template>
          <template #lost="{ row }">{{ row[1].lost }}</template>
          <template #refused="{ row }">{{ row[1].refused }}</template>
          <template #pre_confirmed="{ row }">{{ row[1].pre_confirmed }}</template>
          <template #deposit_paid="{ row }">{{ row[1].deposit_paid }}</template>
          <template #full_paid="{ row }">{{ row[1].full_paid }}</template>
          <template #completed="{ row }">{{ row[1].completed }}</template>
          <template #conversion="{ row }">{{ row[1].conversion }}%</template>
          <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
        </v-client-table>
        <app-cells><h2 class="title">Preferred communication method</h2></app-cells>
        <v-client-table
          :data="table_preferable.items"
          :columns="table_preferable.columns"
          :options="table_preferable.options"
          class="table-default"
        >
          <template #h__country><div class="table-default__left">Communication method</div></template>
          <template #h__pre_confirmed>Pre<br>confirmed</template>
          <template #h__deposit_paid>Deposit<br>paid</template>
          <template #h__full_paid>Full<br>paid</template>
          <template #index="{ row, index }">{{ index }}</template>
          <template #country="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
          <template #count="{ row }">{{ row[1].count }}</template>
          <template #lead="{ row }">{{ row[1].lead }}</template>
          <template #negotiation="{ row }">{{ row[1].negotiation }}</template>
          <template #nurture="{ row }">{{ row[1].nurture }}</template>
          <template #postponed="{ row }">{{ row[1].postponed }}</template>
          <template #no_response="{ row }">{{ row[1].no_response }}</template>
          <template #lost="{ row }">{{ row[1].lost }}</template>
          <template #refused="{ row }">{{ row[1].refused }}</template>
          <template #pre_confirmed="{ row }">{{ row[1].pre_confirmed }}</template>
          <template #deposit_paid="{ row }">{{ row[1].deposit_paid }}</template>
          <template #full_paid="{ row }">{{ row[1].full_paid }}</template>
          <template #completed="{ row }">{{ row[1].completed }}</template>
          <template #conversion="{ row }">{{ row[1].conversion }}%</template>
          <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
        </v-client-table>
        <app-cells><h2 class="title">Devices</h2></app-cells>
        <v-client-table
          :data="table_devices.items"
          :columns="table_devices.columns"
          :options="table_devices.options"
          class="table-default"
        >
          <template #h__country><div class="table-default__left">Device</div></template>
          <template #h__pre_confirmed>Pre<br>confirmed</template>
          <template #h__deposit_paid>Deposit<br>paid</template>
          <template #h__full_paid>Full<br>paid</template>
          <template #index="{ row, index }">{{ index }}</template>
          <template #country="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
          <template #count="{ row }">{{ row[1].count }}</template>
          <template #lead="{ row }">{{ row[1].lead }}</template>
          <template #negotiation="{ row }">{{ row[1].negotiation }}</template>
          <template #nurture="{ row }">{{ row[1].nurture }}</template>
          <template #postponed="{ row }">{{ row[1].postponed }}</template>
          <template #no_response="{ row }">{{ row[1].no_response }}</template>
          <template #lost="{ row }">{{ row[1].lost }}</template>
          <template #refused="{ row }">{{ row[1].refused }}</template>
          <template #pre_confirmed="{ row }">{{ row[1].pre_confirmed }}</template>
          <template #deposit_paid="{ row }">{{ row[1].deposit_paid }}</template>
          <template #full_paid="{ row }">{{ row[1].full_paid }}</template>
          <template #completed="{ row }">{{ row[1].completed }}</template>
          <template #conversion="{ row }">{{ row[1].conversion }}%</template>
          <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
        </v-client-table>
        <app-cells><h2 class="title">Lead Magnets</h2></app-cells>
        <v-client-table
          :data="table_magnet.items"
          :columns="table_magnet.columns"
          :options="table_magnet.options"
          class="table-default table-default--40 table-default--indent"
        >
          <template #h__country><div class="table-default__left">Lead Magnet</div></template>
          <template #index="{ row, index }">{{ index }}</template>
          <template #country="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
          <template #count="{ row }">{{ row[1].count }}</template>
        </v-client-table>
        <div class="charts-grid"><highcharts :options="graph_request_magnet_options" /></div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  getCountries,
  getCountryGroups,
  getDeviceTypes,
  getLanguages,
  getLeadsAnalyticsActivitiesClimbing,
  getLeadsAnalyticsActivitiesSafari,
  getLeadsAnalyticsLanguages,
  getLeadsAnalyticsLanguagesGraph,
  getLeadsAnalyticsRequestsActivities,
  getLeadsAnalyticsRequestsActivitiesGraph,
  getLeadsAnalyticsRequestsAssignmentGraph,
  getLeadsAnalyticsRequestsConfirmationGraph,
  getLeadsAnalyticsRequestsCount,
  getLeadsAnalyticsRequestsCountGraph,
  getLeadsAnalyticsRequestsCountries,
  getLeadsAnalyticsRequestsCurrency,
  getLeadsAnalyticsRequestsDevices,
  getLeadsAnalyticsRequestsHoursGraph,
  getLeadsAnalyticsRequestsLeadMagnetGraph,
  getLeadsAnalyticsRequestsMagnets,
  getLeadsAnalyticsRequestsPreferable,
  getLeadsAnalyticsRequestsSourceGraph,
  getLeadsAnalyticsRequestsSources,
  getLeadsAnalyticsRequestsTourOperators,
  getLeadsAnalyticsRequestsWeekdaysGraph,
  getLeadsSources,
  getLeadsStatuses,
  getUsers,
} from '@/http'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { Chart } from 'highcharts-vue'
import moment from 'moment'

export default {
  name: 'CRMAnalyticsRequests',
  components: { VueCtkDateTimePicker, highcharts: Chart },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      date_picker_error: false,
      custom_shortcuts: [
        { key: 'last7Days', label: 'Last 7 days', value: 7 },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
      filter_dates_dates: {
        start: `${moment().year()}-01-01`,
        end: `${moment().year()}-12-31`
      },
      date_picker_dates_error: false,
      custom_shortcuts_dates: [
        {
          key: 'next30Days',
          label: 'Next 30 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(30, 'days')
            }
          }
        },
        {
          key: 'next60Days',
          label: 'Next 60 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(60, 'days')
            }
          }
        },
        {
          key: 'next90Days',
          label: 'Next 90 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(90, 'days')
            }
          }
        },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'thisYear', label: 'This year', value: 'year' },
      ],
      request_data: {},
      graph_request_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_request_weekdays_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_request_hours_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      table_countries: {
        items: [],
        columns: [
          'index',
          'country',
          'count',
          'lead',
          'negotiation',
          'nurture',
          'no_response',
          'lost',
          'refused',
          'pre_confirmed',
          'postponed',
          'deposit_paid',
          'full_paid',
          'completed',
          'conversion',
          'confirmed',
          'amount',
          'commission'
        ],
        options: {
          headings: {
            'index': '#',
            'country': 'Country',
            'count': 'Count',
            'lead': 'Lead',
            'negotiation': 'Negotiation ',
            'nurture': 'Nurture',
            'no_response': 'NR',
            'lost': 'Lost',
            'refused': 'Refused',
            'pre_confirmed': 'Pre confirmed',
            'postponed': 'Postponed',
            'deposit_paid': 'Deposit paid',
            'full_paid': 'Full paid',
            'completed': 'Completed',
            'conversion': 'Conversion',
            'confirmed': 'Confirmed',
            'amount': 'Total sales',
            'commission': 'Commission',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      countries_data: {},
      table_source: {
        items: [],
        columns: [
          'index',
          'country',
          'count',
          'lead',
          'negotiation',
          'nurture',
          'no_response',
          'lost',
          'refused',
          'pre_confirmed',
          'postponed',
          'deposit_paid',
          'full_paid',
          'completed',
          'conversion',
          'confirmed',
        ],
        options: {
          headings: {
            'index': '#',
            'country': 'Country',
            'count': 'Count',
            'lead': 'Lead',
            'negotiation': 'Negotiation ',
            'nurture': 'Nurture',
            'no_response': 'NR',
            'lost': 'Lost',
            'refused': 'Refused',
            'pre_confirmed': 'Pre confirmed',
            'postponed': 'Postponed',
            'deposit_paid': 'Deposit paid',
            'full_paid': 'Full paid',
            'completed': 'Completed',
            'conversion': 'Conversion',
            'confirmed': 'Confirmed',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_preferable: {
        items: [],
        columns: [
          'index',
          'country',
          'count',
          'lead',
          'negotiation',
          'nurture',
          'no_response',
          'lost',
          'refused',
          'pre_confirmed',
          'postponed',
          'deposit_paid',
          'full_paid',
          'completed',
          'conversion',
          'confirmed',
        ],
        options: {
          headings: {
            'index': '#',
            'country': 'Country',
            'count': 'Count',
            'lead': 'Lead',
            'negotiation': 'Negotiation ',
            'nurture': 'Nurture',
            'no_response': 'NR',
            'lost': 'Lost',
            'refused': 'Refused',
            'pre_confirmed': 'Pre confirmed',
            'postponed': 'Postponed',
            'deposit_paid': 'Deposit paid',
            'full_paid': 'Full paid',
            'completed': 'Completed',
            'conversion': 'Conversion',
            'confirmed': 'Confirmed',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_devices: {
        items: [],
        columns: [
          'index',
          'country',
          'count',
          'lead',
          'negotiation',
          'nurture',
          'no_response',
          'lost',
          'refused',
          'pre_confirmed',
          'postponed',
          'deposit_paid',
          'full_paid',
          'completed',
          'conversion',
          'confirmed',
        ],
        options: {
          headings: {
            'index': '#',
            'country': 'Country',
            'count': 'Count',
            'lead': 'Lead',
            'negotiation': 'Negotiation ',
            'nurture': 'Nurture',
            'no_response': 'NR',
            'lost': 'Lost',
            'refused': 'Refused',
            'pre_confirmed': 'Pre confirmed',
            'postponed': 'Postponed',
            'deposit_paid': 'Deposit paid',
            'full_paid': 'Full paid',
            'completed': 'Completed',
            'conversion': 'Conversion',
            'confirmed': 'Confirmed',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_magnet: {
        items: [],
        columns: [
          'index',
          'country',
          'count',
        ],
        options: {
          headings: {
            'index': '#',
            'country': 'Lead Magnet',
            'count': 'Count',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_operators: {
        items: [],
        columns: [
          'index',
          'country',
          'count',
          'lead',
          'negotiation',
          'nurture',
          'no_response',
          'lost',
          'refused',
          'pre_confirmed',
          'postponed',
          'deposit_paid',
          'full_paid',
          'completed',
          'conversion',
          'confirmed',
          'amount',
          'commission'
        ],
        options: {
          headings: {
            'index': '#',
            'country': 'Country',
            'count': 'Count',
            'lead': 'Lead',
            'negotiation': 'Negotiation ',
            'nurture': 'Nurture',
            'no_response': 'NR',
            'lost': 'Lost',
            'refused': 'Refused',
            'pre_confirmed': 'Pre confirmed',
            'postponed': 'Postponed',
            'deposit_paid': 'Deposit paid',
            'full_paid': 'Full paid',
            'completed': 'Completed',
            'conversion': 'Conversion',
            'confirmed': 'Confirmed',
            'amount': 'Total sales',
            'commission': 'Commission',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_currency: {
        items: [],
        columns: [
          'index',
          'country',
          'count',
          'lead',
          'negotiation',
          'nurture',
          'no_response',
          'lost',
          'refused',
          'pre_confirmed',
          'postponed',
          'deposit_paid',
          'full_paid',
          'completed',
          'conversion',
          'confirmed',
          'amount',
          'commission'
        ],
        options: {
          headings: {
            'index': '#',
            'country': 'Country',
            'count': 'Count',
            'lead': 'Lead',
            'negotiation': 'Negotiation ',
            'nurture': 'Nurture',
            'no_response': 'NR',
            'lost': 'Lost',
            'refused': 'Refused',
            'pre_confirmed': 'Pre confirmed',
            'postponed': 'Postponed',
            'deposit_paid': 'Deposit paid',
            'full_paid': 'Full paid',
            'completed': 'Completed',
            'conversion': 'Conversion',
            'confirmed': 'Confirmed',
            'amount': 'Total sales',
            'commission': 'Commission',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      graph_request_source_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_request_languages_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      languages_data: {},
      graph_request_activities_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_climbing_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_safari_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_assignment_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_confirmation_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_request_magnet_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      activities_data: {},
      country_groups_options: [],
      country_group: null,
      country_options: [],
      country: null,
      language_options: [],
      language: null,
      device_options: [],
      device: null,
      climbing_radio: null,
      climbing_radio_options: [
        { value: null, label: 'Not specified' },
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' },
      ],
      safari_radio: null,
      safari_radio_options: [
        { value: null, label: 'Not specified' },
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' },
      ],
      trips_radio: null,
      trips_radio_options: [
        { value: null, label: 'Not specified' },
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' },
      ],
      islands_radio: null,
      islands_radio_options: [
        { value: null, label: 'Not specified' },
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' },
      ],
      status_options: [],
      status: [],
      source_options: [],
      source: [],
      managers_options: [],
      manager: null,
      hours_filter: 6,
      pax_data: {
        climbing: null,
        safari: null,
      },
    }
  },
  created() {
    getCountryGroups().then(response => { this.country_groups_options = response.data })
    getCountries().then(response => { this.country_options = response.data })
    getLanguages().then(response => { this.language_options = response.data })
    getLeadsStatuses().then(response => { this.status_options = response.data })
    getLeadsSources().then(response => { this.source_options = response.data })
    getUsers({ group: 'sales_manager', is_active: true }).then(response => { this.managers_options = response.data })
    getDeviceTypes().then(response => { this.device_options = response.data })
    setTimeout(() => {
      this.$nextTick(() => {
        this.getAllRequests()
      })
    }, 0)
  },
  methods: {
    getAllRequests() {
      this.is_loaded = false
      Promise.all([
        this.fetchRequestCount(),
        this.fetchRequestCountGraph(),
        this.fetchRequestWeekdays(),
        this.fetchRequestHours(),
        this.fetchRequestCountries(),
        this.fetchRequestSources(),
        this.fetchRequestTourOperators(),
        this.fetchRequestCurrency(),
        this.fetchRequestLanguagesData(),
        this.fetchRequestLanguagesGraph(),
        this.fetchRequestPreferable(),
        this.fetchRequestActivities(),
        this.fetchRequestActivitiesGraph(),
        this.fetchActivitiesClimbingGraph(),
        this.fetchActivitiesSafariGraph(),
        this.fetchRequestAssignmentGraph(),
        this.fetchRequestConfirmationGraph(),
        this.fetchRequestDevices(),
        this.fetchRequestMagnets(),
        this.fetchRequestMagnetsGraph(),
        this.fetchRequestSourceGraph()
      ])
        .then(() => { this.is_loaded = true })
    },
    async fetchRequestSourceGraph() {
      const response = await getLeadsAnalyticsRequestsSourceGraph({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.graph_request_source_options.xAxis.categories = response.data.categories
      this.graph_request_source_options.series = response.data.series
    },
    async fetchRequestMagnetsGraph() {
      const response = await getLeadsAnalyticsRequestsLeadMagnetGraph({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.graph_request_magnet_options.xAxis.categories = response.data.categories
      this.graph_request_magnet_options.series = response.data.series
    },
    async fetchRequestAssignmentGraph() {
      const response = await getLeadsAnalyticsRequestsAssignmentGraph({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.graph_assignment_options.xAxis.categories = response.data.categories
      this.graph_assignment_options.series = response.data.series
    },
    async fetchRequestConfirmationGraph() {
      const response = await getLeadsAnalyticsRequestsConfirmationGraph({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.graph_confirmation_options.xAxis.categories = response.data.categories
      this.graph_confirmation_options.series = response.data.series
    },
    async fetchActivitiesClimbingGraph() {
      const response = await getLeadsAnalyticsActivitiesClimbing({
        from_date: this.filter_dates_dates.start,
        to_date: this.filter_dates_dates.end,
        from_request_date: this.filter_dates.start,
        to_request_date: this.filter_dates.end,
      })
      this.graph_climbing_options.xAxis.categories = response.data.graph.categories
      this.graph_climbing_options.series = response.data.graph.series
      this.pax_data.climbing = response.data.total_count
    },
    async fetchActivitiesSafariGraph() {
      const response = await getLeadsAnalyticsActivitiesSafari({
        from_date: this.filter_dates_dates.start,
        to_date: this.filter_dates_dates.end,
        from_request_date: this.filter_dates.start,
        to_request_date: this.filter_dates.end,
      })
      this.graph_safari_options.xAxis.categories = response.data.graph.categories
      this.graph_safari_options.series = response.data.graph.series
      this.pax_data.safari = response.data.total_count
    },
    async fetchRequestActivities() {
      const response = await getLeadsAnalyticsRequestsActivities({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.activities_data = response.data.items
    },
    async fetchRequestActivitiesGraph() {
      const response = await getLeadsAnalyticsRequestsActivitiesGraph({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.graph_request_activities_options.xAxis.categories = response.data.categories
      this.graph_request_activities_options.series = response.data.series
    },
    async fetchRequestCount() {
      const response = await getLeadsAnalyticsRequestsCount({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.request_data = response.data
    },
    async fetchRequestCountGraph() {
      const response = await getLeadsAnalyticsRequestsCountGraph({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.graph_request_options.xAxis.categories = response.data.categories
      this.graph_request_options.series = response.data.series
    },
    async fetchRequestWeekdays() {
      const response = await getLeadsAnalyticsRequestsWeekdaysGraph({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.graph_request_weekdays_options.xAxis.categories = response.data.categories
      this.graph_request_weekdays_options.series = response.data.series
    },
    async fetchRequestHours() {
      const response = await getLeadsAnalyticsRequestsHoursGraph({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        action: this.hours_filter,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.graph_request_hours_options.xAxis.categories = response.data.categories
      this.graph_request_hours_options.series = response.data.series
    },
    async fetchRequestCountries() {
      const response = await getLeadsAnalyticsRequestsCountries({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.table_countries.items = Object.entries(response.data.countries)
      this.countries_data = { exist: response.data.exist, missing: response.data.missing }
    },
    async fetchRequestSources() {
      const response = await getLeadsAnalyticsRequestsSources({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.table_source.items = Object.entries(response.data.sources)
    },
    async fetchRequestPreferable() {
      const response = await getLeadsAnalyticsRequestsPreferable({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.table_preferable.items = Object.entries(response.data.instances)
    },
    async fetchRequestDevices() {
      const response = await getLeadsAnalyticsRequestsDevices({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.table_devices.items = Object.entries(response.data.instances)
    },
    async fetchRequestMagnets() {
      const response = await getLeadsAnalyticsRequestsMagnets({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.table_magnet.items = Object.entries(response.data.instances)
    },
    async fetchRequestTourOperators() {
      const response = await getLeadsAnalyticsRequestsTourOperators({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.table_operators.items = Object.entries(response.data.tour_operators)
    },
    async fetchRequestCurrency() {
      const response = await getLeadsAnalyticsRequestsCurrency({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.table_currency.items = Object.entries(response.data.instances)
    },
    async fetchRequestLanguagesData() {
      const response = await getLeadsAnalyticsLanguages({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.languages_data = response.data.languages
    },
    async fetchRequestLanguagesGraph() {
      const response = await getLeadsAnalyticsLanguagesGraph({
        from_date: this.filter_dates.start,
        to_date: this.filter_dates.end,
        country_group: this.country_group,
        country: this.country,
        language: this.language,
        device: this.device,
        manager: this.manager,
        source: this.source.length ? this.source : '',
        status: this.status.length ? this.status : '',
        climbing: this.climbing_radio,
        day_trip: this.trips_radio,
        island: this.islands_radio,
        safari: this.safari_radio,
      })
      this.graph_request_languages_options.xAxis.categories = response.data.categories
      this.graph_request_languages_options.series = response.data.series
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.getAllRequests()
      } else this.date_picker_error = true
    },
    onIsHiddenPickerDates() {
      if (this.filter_dates_dates?.start && this.filter_dates_dates?.end) {
        this.date_picker_error = false
        this.fetchActivitiesClimbingGraph()
        this.fetchActivitiesSafariGraph()
      } else this.date_picker_error = true
    },
    onInputCountryGroup() {
      this.getAllRequests()
    },
  }
}
</script>

<style lang="sass" scoped>
.date-picker-wrapper
  position: relative

.date-picker-wrapper__error
  position: absolute
  bottom: -18px
  color: $color-error
  font-size: 12px

.lead-holder
  min-height: 500px
</style>
